import FeedModule from "modules/Core/core-modules/FeedModule";
import { RELEASES } from "../consts";

export default new FeedModule({
  name: RELEASES,
  cellOptions: {},
});
